import React, { useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = React.createContext(null);

export const SocketProvider = (props) => {
    const [value] = useState(() => io({ transports: ['websocket'], autoConnect: false }));
    useEffect(() => {
        value.connect();
        return () => value.disconnect();
    }, [value]);

    return(
        <SocketContext.Provider value={value}>
            {props.children}
        </SocketContext.Provider>
    )
}

export const useSocket = () => {
    return useContext(SocketContext);
}
